import { ComponentType } from '~/shared/domain/models';
import type { FieldSelectSchema, AnyComponentSchema } from '~/shared/domain/models';

export function isFieldSelect(field: AnyComponentSchema): field is FieldSelectSchema {
  return field.componentType === ComponentType.FieldSelect;
}
